import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { of, Observable, Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { ButtonSize } from '@fcom/ui-components';
import { CmsTemplate, CmsContent } from '@fcom/core-api';
import { CmsTemplateService } from '@fcom/cms';
import { PageMetaService } from '@fcom/common';
import { LoyaltyRoutesPath, setPageMetadata } from '@fcom/loyalty-core';
import { RootPaths } from '@fcom/core/constants';

@Component({
  selector: 'fin-loyalty-upgrade-travel-class',
  templateUrl: './upgrade-travel-class.component.html',
  styleUrls: ['../../../loyalty-core/assets/styles/common.scss'],
  standalone: false,
})
export class UpgradeTravelClassComponent implements OnInit, OnDestroy, AfterViewInit {
  public readonly ButtonSize = ButtonSize;

  template$: Observable<CmsTemplate>;
  pageTitle$: Observable<string>;
  pageViewType$: Observable<string> = of('');
  upgradeUrl = `/${this.languageService.langValue}/${RootPaths.ONE_UPGRADE_ROOT}`;
  upgradeTermsLink$: Observable<CmsContent> = of(null);

  private ngDestroyed$ = new Subject();

  constructor(
    private cmsTemplateService: CmsTemplateService,
    private languageService: LanguageService,
    private pageMetaService: PageMetaService,
    private router: Router
  ) {}

  ngOnInit() {
    this.template$ = this.cmsTemplateService.load(
      `/${this.languageService.langValue}/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.UPGRADE_AVAILABILITY}`
    );
    this.pageTitle$ = this.template$.pipe(map((template: CmsTemplate) => template?.header?.[0]?.title ?? ''));
    this.upgradeTermsLink$ = this.template$.pipe(
      map((template: CmsTemplate) =>
        template?.main?.find((content: CmsContent): CmsContent => content.localSettings?.isUpgradeTermsTeaser)
      ),
      takeUntil(this.ngDestroyed$)
    );
  }

  ngAfterViewInit(): void {
    this.template$
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe((template: CmsTemplate) => setPageMetadata(template, this.pageMetaService));
  }

  ngOnDestroy(): void {
    this.ngDestroyed$.next(true);
  }

  upgradeTo(): void {
    this.router.navigateByUrl(this.upgradeUrl);
  }
}
